import request from '@/utils/requestBusiness'

export function list(data) {
  return request({
    url: '/role/queryRolePage',
    method: 'post',
    data
  })
}

export function add(data) {
  return request({
    url: '/role/addRole',
    method: 'post',
    data
  })
}

export function remove(params) {
  return request({
    url: '/role/deleteRole',
    method: 'delete',
    params
  })
}

export function updateName(params) {
  return request({
    url: '/role/updateRoleName',
    method: 'get',
    params
  })
}

export function updateRoleUser(data) {
  return request({
    url: '/role/updateRoleUser',
    method: 'post',
    data
  })
}

export function updateRoleFunction(data) {
  return request({
    url: '/role/updateRoleFunction',
    method: 'post',
    data
  })
}

export function detail(params) {
  return request({
    url: '/role/findDetailById',
    method: 'get',
    params
  })
}

export function userRoleList(params) {
  return request({
    url: '/role/findRoleListByUserId',
    method: 'get',
    params
  })
}
